// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1X_QM","select":"styles_select__20vRd"};